export default {
  'FooterContainer.PageSizeSelector.CountDropdown': ({ pageSize }, outlet) => {
    outlet({ pageSize, pageNumber:0 });
  },

  'FooterContainer.PageSelector': ({ pageNumber }, outlet) => {
    outlet({ pageNumber });
  }
}